<template>
  <div style="padding: 0px" class="sub-view">
    <div class="table-navigation">
      <!-- list filter -->
      <div class="list-filter">
        <!-- filter tanggal-->
        <div style="margin-right: 12px" class="filter-pilihan">
          <label for="date-picker" class="filter">
            <!-- tipe filter -->
            <p>Tanggal :</p>
            <!-- value filter -->
            <span>{{ filterData.tanggal ? filterData.tanggal : "Semua" }}</span>
            <!-- icon filter -->
            <svg
              width="10"
              height="7"
              viewBox="0 0 10 7"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.714294 1.35742L5.00001 5.64314L9.28572 1.35742"
                stroke="#A0A3BD"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <!-- input elemen -->
            <input
              v-model="filterData.tanggal"
              id="date-picker"
              class="date-control"
              type="date"
            />
          </label>
        </div>
        <!-- end of filter tanggal -->

        <!-- filter Divisi-->
        <div class="filter-pilihan">
          <div @click="openClosePilihanDivisi(true)" class="filter">
            <!-- tipe filter -->
            <p>Divisi :</p>
            <!-- value filter -->
            <span>{{ filterData.divisi ? filterData.divisi : "Semua" }}</span>
            <!-- icon filter -->
            <svg
              width="10"
              height="7"
              viewBox="0 0 10 7"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.714294 1.35742L5.00001 5.64314L9.28572 1.35742"
                stroke="#A0A3BD"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>

          <!-- box pilihan filter -->
          <div
            style="margin-top: 2px; display: none"
            ref="boxPilihanDivisi"
            class="box-pilihan"
          >
            <p
              v-for="divisi in listDivisi"
              :key="divisi"
              @click="openClosePilihanDivisi(false, divisi)"
              style="border-top: 1px solid #ebeff2"
            >
              {{ divisi }}
              <svg
                v-if="divisi === filterData.divisi"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.7142 5.71484L7.85707 13.572L4.28564 10.0006"
                  stroke="#00BA88"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </p>
          </div>
          <!-- end of box pilihan filter -->
        </div>
        <!-- end of filter Divisi-->
      </div>
      <!-- end of list filter -->

      <!-- bagian untuk cari tambah dan download -->
      <div class="cari-tambah-download">
        <!-- box pencarian -->
        <div class="cari">
          <svg
            style="margin-right: 8px"
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.4286 13.4294L10.3214 10.3223M12 6.28655C12 9.44246 9.44161 12.0008 6.2857 12.0008C3.12978 12.0008 0.571411 9.44246 0.571411 6.28655C0.571411 3.13064 3.12978 0.572266 6.2857 0.572266C9.44161 0.572266 12 3.13064 12 6.28655Z"
              stroke="#A0A3BD"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>

          <input
            v-model="filterData.pencarian"
            placeholder="Cari"
            type="text"
            name=""
            id=""
          />
        </div>
        <!-- button download -->
        <button @click="downloadData" class="download">
          <svg
            width="16"
            height="16"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.4286 9.14375V12.0009C13.4286 12.3798 13.278 12.7431 13.0101 13.011C12.7422 13.279 12.3789 13.4295 12 13.4295H1.99998C1.6211 13.4295 1.25774 13.279 0.98983 13.011C0.721921 12.7431 0.571411 12.3798 0.571411 12.0009V9.14375M3.42855 5.57227L6.99998 9.14369M6.99998 9.14369L10.5714 5.57227M6.99998 9.14369V0.572266"
              stroke="#FCFCFC"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
        <!-- open menu mobile -->
        <div class="open-menu-mobile">
          <!-- menu icon -->
          <svg
            @click="openCloseMenuMobile(true)"
            width="14"
            height="4"
            viewBox="0 0 14 4"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6.99993 2.71422C7.39442 2.71422 7.71422 2.39442 7.71422 1.99993C7.71422 1.60544 7.39442 1.28564 6.99993 1.28564C6.60544 1.28564 6.28564 1.60544 6.28564 1.99993C6.28564 2.39442 6.60544 2.71422 6.99993 2.71422Z"
              stroke="#A0A3BD"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M11.9999 2.71422C12.3944 2.71422 12.7142 2.39442 12.7142 1.99993C12.7142 1.60544 12.3944 1.28564 11.9999 1.28564C11.6054 1.28564 11.2856 1.60544 11.2856 1.99993C11.2856 2.39442 11.6054 2.71422 11.9999 2.71422Z"
              stroke="#A0A3BD"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M1.99993 2.71422C2.39442 2.71422 2.71422 2.39442 2.71422 1.99993C2.71422 1.60544 2.39442 1.28564 1.99993 1.28564C1.60544 1.28564 1.28564 1.60544 1.28564 1.99993C1.28564 2.39442 1.60544 2.71422 1.99993 2.71422Z"
              stroke="#A0A3BD"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <!-- end of menu icon -->
          <div
            style="display: none"
            ref="box-pilihan-menu"
            class="box-pilihan-aksi"
          >
            <!-- buka menu filter -->
            <p @click="openCloseFilterMobile(true)">
              <svg
                width="17"
                height="15"
                viewBox="0 0 17 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16.2437 0.571289H1.04053L7.12179 7.32843V12.7141L10.1624 14.1427V7.32843L16.2437 0.571289Z"
                  stroke="#4E4B66"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              Filter
            </p>
            <!-- melakukan downlaod -->
            <p @click="downloadData">
              <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.4287 9.14277V11.9999C13.4287 12.3788 13.2782 12.7422 13.0103 13.0101C12.7423 13.278 12.379 13.4285 12.0001 13.4285H2.0001C1.62122 13.4285 1.25786 13.278 0.989952 13.0101C0.722043 12.7422 0.571533 12.3788 0.571533 11.9999V9.14277M3.42868 5.57129L7.0001 9.14272M7.0001 9.14272L10.5715 5.57129M7.0001 9.14272V0.571289"
                  stroke="#00BA88"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              Download
            </p>
          </div>
        </div>
        <!-- end of open menu mobile -->
      </div>
    </div>
    <!-- end of bagian untuk cari tambah dan download -->

    <!-- filter mobile -->
    <div style="bottom: -100%" ref="filter-mobile" class="backdrop">
      <div class="filter-mobile">
        <div class="filter-mobile-title">
          <h5>
            Filter <br />
            Rekap Presensi - Cuti
          </h5>
          <!-- close filter -->
          <svg
            @click="openCloseFilterMobile(false)"
            width="10"
            height="10"
            viewBox="0 0 10 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.28566 0.714355L0.714233 9.28578M0.714233 0.714355L9.28566 9.28578"
              stroke="#1A1A1A"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>

        <!-- input tanggal -->
        <label tabindex="0" for="date-picker-lahir" class="box-form email">
          <svg
            width="14"
            height="16"
            viewBox="0 0 14 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.85725 0.857422V3.71456M4.14296 0.857422V3.71456M0.571533 6.57171H13.4287M2.0001 2.28599H12.0001C12.7891 2.28599 13.4287 2.92559 13.4287 3.71456V13.7146C13.4287 14.5035 12.7891 15.1431 12.0001 15.1431H2.0001C1.21113 15.1431 0.571533 14.5035 0.571533 13.7146V3.71456C0.571533 2.92559 1.21113 2.28599 2.0001 2.28599Z"
              stroke="#A0A3BD"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <div style="position: relative" class="input-and-title">
            <span v-if="filterData.tanggal" class="input-title">Tanggal</span>
            <input
              style="width: 200px; height: 50px"
              id="date-picker-lahir"
              class="date-control"
              type="date"
              v-model="filterData.tanggal"
            />
            <p>
              {{ filterData.tanggal ? filterData.tanggal : "Tanggal" }}
            </p>
          </div>
        </label>
        <!-- end of input tanggal -->

        <!-- input divisi -->
        <div class="keterangan input-keterangan">
          <div
            @click="openClosePilihanDivisiMobile(true)"
            ref="keterangan-form"
            class="box-form email"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.857178 11.5712L8.00003 15.1426L15.1429 11.5712M0.857178 7.99979L8.00003 11.5712L15.1429 7.99979M8.00003 0.856934L0.857178 4.42836L8.00003 7.99979L15.1429 4.42836L8.00003 0.856934Z"
                stroke="#A0A3BD"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>

            <div class="input-and-title">
              <span
                v-if="filterData.divisi"
                style="display: block"
                class="input-title"
                >Divisi</span
              >
              <p>
                {{ filterData.divisi ? filterData.divisi : "Divisi" }}
              </p>
            </div>
          </div>
          <!-- box pilihan divisi -->
          <div
            style="display: none"
            ref="boxPilihanDivisiMobile"
            class="box-pilihan"
          >
            <p
              @click="openClosePilihanDivisiMobile(false, divisi)"
              v-for="divisi in listDivisi"
              :key="divisi"
            >
              {{ divisi }}
              <svg
                v-if="divisi === filterData.divisi"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.7142 5.71484L7.85707 13.572L4.28564 10.0006"
                  stroke="#00BA88"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </p>
          </div>
          <!-- end of box pilihan divisi -->
        </div>
        <!-- end of input divisi -->
        <div class="button-container">
          <button @click="openCloseFilterMobile(false)" class="yellow-button">
            Terapkan
          </button>
        </div>
      </div>
    </div>
    <!-- end of filter mobile -->

    <div class="box-table">
      <table>
        <!-- judul tabel  -->
        <tr>
          <th>Tanggal Pengajuan</th>
          <th>Nama Karyawan</th>
          <th>Cabang</th>
          <th style="width: 16%">Waktu</th>
          <th>Tipe</th>
          <th>Lampiran</th>
          <th style="width: 18%">HR Review</th>
        </tr>
        <!-- start iterasi tabel -->
        <tr :key="index" v-for="(cuti, index) in filteredRiwayatCuti">
          <!-- tanggal pengajuan -->
          <td>{{ cuti.tanggalPengajuan }}</td>
          <!-- Nama Karyawan, divisi, dan cabang  -->
          <td>
            <span style="color: #1d1d1d; font-weight: 700">{{
              cuti.nama
            }}</span>
            <br />
            {{ cuti.jabatan }}-{{ cuti.divisi }}
          </td>
          <!-- Cabang  -->
          <td>
            {{ userData.penempatan }}
          </td>
          <!-- waktu  -->
          <td>
            Mulai:
            <span class="red-text">{{ cuti.tanggalMulai }}</span>
            <br />
            Akhir:
            <span class="red-text">{{ cuti.tanggalAkhir }}</span>
          </td>
          <!-- tipe  -->
          <td class="tipe-cuti"><span>Cuti</span></td>
          <!-- lampiran absen -->
          <td class="tabel-lampiran">
            <p @click="openCloseModalKeterangan(true, cuti.keterangan)">
              <span>Keterangan</span>
            </p>
            <p @click="openCloseModalViewer(true, cuti.lampiran[0])">
              <span>Dokumen</span>
            </p>
          </td>
          <!-- hasil review HR -->
          <td
            @mouseleave="openCloseAction(false, index)"
            @mouseover="openCloseAction(true, index)"
            v-if="cuti.status === 'rejected'"
            class="hasil-review-tolak"
          >
            <p class="detail-review">
              <span>TOLAK</span> {{ toClock(cuti.reviewTimestamp._seconds) }}
            </p>
            <p>oleh {{ cuti.reviewer }}</p>
            <div
              style="display: none"
              ref="box-pilihan-aksi"
              class="box-pilihan-aksi aksi-edit-presensi"
            >
              <p @click="editReview('accepted')">
                <svg
                  width="14"
                  height="10"
                  viewBox="0 0 14 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12.7236 0.713867L4.36182 8.57101L0.561035 4.99958"
                    stroke="#00BA88"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                Acc
              </p>
              <p @click="editReview('rejected')">
                <svg
                  width="10"
                  height="10"
                  viewBox="0 0 10 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.28578 0.713867L0.714355 9.2853M0.714355 0.713867L9.28578 9.2853"
                    stroke="#EB5757"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                Tolak
              </p>
            </div>
          </td>

          <td
            @mouseleave="openCloseAction(false, index)"
            @mouseover="openCloseAction(true, index)"
            v-else-if="cuti.status === 'accepted'"
            class="hasil-review-acc"
          >
            <p class="detail-review">
              <span>ACC</span> {{ toClock(cuti.reviewTimestamp._seconds) }}
            </p>
            <p>oleh {{ cuti.reviewer }}</p>
            <div
              style="display: none"
              ref="box-pilihan-aksi"
              class="box-pilihan-aksi aksi-edit-presensi"
            >
              <p @click="editReview('accepted')">
                <svg
                  width="14"
                  height="10"
                  viewBox="0 0 14 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12.7236 0.713867L4.36182 8.57101L0.561035 4.99958"
                    stroke="#00BA88"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                Acc
              </p>
              <p @click="editReview('rejected')">
                <svg
                  width="10"
                  height="10"
                  viewBox="0 0 10 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.28578 0.713867L0.714355 9.2853M0.714355 0.713867L9.28578 9.2853"
                    stroke="#EB5757"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                Tolak
              </p>
            </div>
          </td>

          <td v-else class="hasil-review-proses">
            <p class="detail-review"><span>PENDING</span></p>
          </td>
        </tr>
        <!-- end iterasi tabel -->
      </table>
      <p v-if="isProsesData" class="empty-state-table">Memproses data..</p>
      <p
        v-else-if="!filteredRiwayatCuti || filteredRiwayatCuti.length === 0"
        class="empty-state-table"
      >
        Belum ada data
      </p>
    </div>

    <!-- modal untuk keterangan -->
    <div v-if="modalKeteranganIsOpen" class="modal-backdrop">
      <div style="width: 445px; height: 220px" class="modal">
        <div class="content">
          <div style="text-align: center" class="text-modal">
            <h2 class="primary-text">Keterangan</h2>
            <p style="font-size: 14px; font-weight: 400; margin-top: 10px">
              {{ keterangan }}
            </p>
          </div>
        </div>
        <!-- close button -->
        <svg
          style="margin-right: -374px; margin-top: -162px"
          @click="openCloseModalKeterangan(false)"
          class="close-button"
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M22.8574 9.14307L9.14307 22.8574M9.14307 9.14307L22.8574 22.8574"
            stroke="#1D1D1D"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <!-- end of close button -->
      </div>
    </div>
    <!-- end of modal untuk keterangan -->

    <!-- modal view lampiran -->
    <ModalViewer v-if="modalViewerIsOpen">
      <div style="text-align: center" class="modal-content-viewer">
        <object
          style="object-fit: cover; margin: 10px 0px"
          :data="urlLampiran"
          width="750"
          height="390"
        ></object>

        <button
          @click="openDokumen"
          style="margin-top: 10px"
          class="yellow-button"
        >
          Buka dokumen
        </button>
      </div>
      <!-- close button -->
      <svg
        @click="openCloseModalViewer(false)"
        style="margin-top: -438px; margin-left: 340px"
        class="close-button"
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22.8574 9.14307L9.14307 22.8574M9.14307 9.14307L22.8574 22.8574"
          stroke="#1D1D1D"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <!-- end of close button -->
    </ModalViewer>
    <!-- end of modal view lampiran -->
  </div>
</template>

<script>
import * as soluhaApi from "@/soluhaApi";
import { mapState } from "vuex";
import ModalViewer from "@/components/modal/RelativeModal";
import * as soluhafire from "@/soluhafire";
import XLSX from "xlsx";

export default {
  components: {
    ModalViewer,
  },

  data() {
    return {
      chosenIndex: null,
      modalKeteranganIsOpen: false,
      modalViewerIsOpen: false,
      // data untuk modal lokasi
      dataModal: {
        urlGambar: "",
        urlLokasi: "",
        namaLokasi: "",
      },
      //variabel filter
      filterData: {
        tanggal: null,
        divisi: "",
        pencarian: "",
      },
      // data modal keterangan
      keterangan: "",
      // data modal view
      urlLampiran: "",
      // yang akan diambil dari api
      riwayatCuti: null,
      // apakah tabel sedang memproses data?
      isProsesData: false,
    };
  },

  methods: {
    async rekapCuti() {
      this.isProsesData = true;
      let listCuti = await soluhaApi.riwayatCuti();
      // buat field tanggal dan tipe untuk Cuti
      listCuti.forEach((element) => {
        element.tanggalPengajuan = element.tanggalPengajuan._seconds;
        element.tanggalMulai = soluhaApi.epochToDate(
          element.tanggalMulai._seconds
        );
        element.tanggalAkhir = soluhaApi.epochToDate(
          element.tanggalAkhir._seconds
        );
        element.tipe = "cuti";
      });

      // sorting berdasarkan tanggal pengajuan
      listCuti.sort((a, b) => b.tanggalPengajuan - a.tanggalPengajuan);
      listCuti.forEach((element) => {
        element.tanggalPengajuan = soluhaApi.epochToDate(
          element.tanggalPengajuan
        );
      });
      // remove pending
      listCuti = listCuti.filter((item) => item.status !== "pending");
      this.riwayatCuti = listCuti;
      this.isProsesData = false;
    },

    // untuk tutup atau buku box filter  Divisi
    openClosePilihanDivisi(open, value) {
      let box = this.$refs.boxPilihanDivisi;
      if (open) {
        box.style.display = "block";
      } else {
        box.style.display = "none";
        this.filterData.divisi = value;
      }
    },

    openClosePilihanDivisiMobile(open, value) {
      let box = this.$refs.boxPilihanDivisiMobile;
      if (open) {
        box.style.display = "block";
      } else {
        box.style.display = "none";
        this.filterData.divisi = value;
      }
    },

    openCloseModalKeterangan(isOpen, keterangan) {
      if (isOpen) {
        this.keterangan = keterangan;
        this.modalKeteranganIsOpen = true;
      } else {
        this.keterangan = "";
        this.modalKeteranganIsOpen = false;
      }
    },

    openCloseModalViewer(isOpen, url) {
      if (isOpen) {
        this.urlLampiran = url;
        this.modalViewerIsOpen = true;
      } else {
        this.urlLampiran = "";
        this.modalViewerIsOpen = false;
      }
    },

    openCloseMenuMobile(isOpen) {
      let box = this.$refs["box-pilihan-menu"];
      if (isOpen) box.style.display = "block";
      else box.style.display = "none";
    },

    openCloseFilterMobile(isOpen) {
      this.openCloseMenuMobile(false);
      let box = this.$refs["filter-mobile"];
      if (isOpen) box.style.bottom = "0px";
      else box.style.bottom = "-100%";
    },

    // untuk edit review (khusus manager)
    openCloseAction(open, index) {
      if (this.userData.jabatan === "manager") {
        let box = this.$refs["box-pilihan-aksi"][index];
        // tutup box action yang lain
        this.$refs["box-pilihan-aksi"].forEach((refs) => {
          refs.style.display = "none";
        });
        if (open) {
          box.style.display = "block";
          this.chosenIndex = index;
        } else {
          box.style.display = "none";
        }
      } else return;
    },

    editReview(review) {
      let docId = this.filteredRiwayatCuti[this.chosenIndex].documentId;
      let result = soluhaApi.reviewCuti(docId, review);
      result
        .then((response) => {
          console.log(response);
          // perbarui data
          this.rekapCuti();
        })
        .catch((error) => {
          console.log(error);
        });
    },

    toClock(time) {
      return soluhafire.epochToClock(time);
    },

    toDate(time) {
      return soluhaApi.epochToDate(time);
    },

    openDokumen() {
      window.open(this.urlLampiran, "_blank");
    },

    downloadData() {
      let dataRiwayat = [];
      this.riwayatCuti.forEach((cuti) => {
        dataRiwayat.push({
          tanggalPengajuan : cuti.tanggalPengajuan,
          nama: cuti.nama,
          divisi: cuti.divisi,
          jabatan: cuti.jabatan,
          mulai: cuti.tanggalMulai,
          akhir: cuti.tanggalAkhir,
          keterangan: cuti.keterangan,
          lampiran: cuti.lampiran[0],
          status: cuti.status,
          reviewer: cuti.reviewer,
        });
      });
      const data = XLSX.utils.json_to_sheet(dataRiwayat);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, data, "data");
      XLSX.writeFile(wb, `data_cuti_${this.userData.penempatan}.xlsx`);
    },
  },

  mounted() {
    this.rekapCuti();
  },

  computed: {
    ...mapState(["userData", "listDivisi"]),

    filteredRiwayatCuti() {
      let riwayatCuti = this.riwayatCuti;
      let filterDivisi = this.filterData.divisi;
      let filterTanggal = this.filterData.tanggal;
      let filterPencarian = this.filterData.pencarian.toLowerCase();

      if (filterDivisi === "semua") filterDivisi = "";
      if (filterTanggal === "semua" || !filterTanggal) filterTanggal = "";
      else {
        let date = new Date(filterTanggal);
        filterTanggal = `${date.getDate()}-${
          date.getMonth() + 1
        }-${date.getFullYear()}`;
      }

      if (riwayatCuti) {
        return riwayatCuti.filter(function (item) {
          let filtered = true;
          if (filterDivisi && filterDivisi.length > 0) {
            filtered = item.divisi == filterDivisi;
          }
          if (filtered) {
            if (filterPencarian && filterPencarian.length > 0) {
              filtered = item.nama.toLowerCase().includes(filterPencarian);
            }
          }
          if (filtered) {
            if (filterTanggal && filterTanggal.length > 0) {
              filtered = item.tanggalPengajuan == filterTanggal;
            }
          }
          return filtered;
        });
      }
      return false;
    },
  },
};
</script>
